import { render, staticRenderFns } from "./ProjectReportWidgets.vue?vue&type=template&id=3ab81a16&scoped=true"
import script from "./ProjectReportWidgets.vue?vue&type=script&lang=js"
export * from "./ProjectReportWidgets.vue?vue&type=script&lang=js"
import style0 from "./ProjectReportWidgets.vue?vue&type=style&index=0&id=3ab81a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab81a16",
  null
  
)

export default component.exports